import React from 'react'
import { connect } from 'react-redux'

import { fetchUserInfo } from 'actions'
import { userTypeSelector } from 'selectors'
import { CONSULTANT, ADMIN, CUSTOMER } from 'userTypes'

import Consultant from 'components/Consultant'
import UserComponent from 'components/User'
import Spinner from 'components/Spinner'

class User extends React.Component {
  componentDidMount = () => this.props.fetchUserInfo(this.props.userId)

  render() {
    if (this.props.userType === CONSULTANT) {
      return <Consultant consultantId={this.props.userId} />
    } else if (
      this.props.userType === ADMIN ||
      this.props.userType === CUSTOMER
    ) {
      return <UserComponent userId={this.props.userId} />
    } else {
      return <Spinner />
    }
  }
}

const mapStateToProps = (state, { match: { params: { userId } } }) => ({
  userId,
  userType: userTypeSelector(state, userId),
})

const mapDispatchToProps = { fetchUserInfo }

export default connect(mapStateToProps, mapDispatchToProps)(User)



// WEBPACK FOOTER //
// ./src/pages/User.js